import React from 'react';
import { Trans } from 'react-i18next';
import { View } from 'react-native';

import { Icon } from '@components/Icon';
import { Typography } from '@components/Typography';
import { useTranslation } from '@providers/I18n';
import { makeStyles, useTheme } from '@providers/Theme';

export type TagProps = {
  isIftar?: Boolean;
  testId?: string;
  pickupTime?: string;
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    backgroundColor: theme.palette.base[100],
    borderColor: theme.palette.grey[500],
    borderRadius: 6,
    borderWidth: 1,
    borderStyle: 'solid',
    ...theme.mixins.padding(0.5, 1),
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
  iftar: {
    flexWrap: 'wrap',
    on: {
      sm: {
        width: 'auto',
      },
      xs: {
        width: '50%',
      },
    },
  },
}));

export const TimeBadge: React.FC<TagProps> = ({
  isIftar,
  testId,
  pickupTime,
}) => {
  const styles = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  const iconSize = isIftar ? 12 : 8;
  return (
    <View style={[styles.root, isIftar && styles.iftar]} testID={testId}>
      <Icon
        name={isIftar ? 'moon-star' : 'dot'}
        size={iconSize}
        color={theme.palette.primary[600]}
        style={styles.icon}
      />
      <Typography variant="cool" weight="medium" size={{ xs: 'md' }}>
        <Trans i18nKey={isIftar ? 'timeBadge.iftar' : 'timeBadge.now'} />{' '}
        {isIftar && t('orderView.PickupBy', 'Pickup by') + ': ' + pickupTime}
      </Typography>
    </View>
  );
};
